import { PATIENT_MENU } from '@/config/navigationMenus';

/** Nav items for patient portal — faculty/staff get referrals + family. */
export function patientMenuItems(isFacultyStaff) {
  if (isFacultyStaff) return PATIENT_MENU;
  return PATIENT_MENU.filter(
    (item) => !item.to.includes('/referrals') && !item.to.includes('/family'),
  );
}
